// 处理 ap-tabs-product-swiper section 中 tab 切换时重新初始化 slider
(function() {
  // 初始化单个轮播组件
  function initSlider(slider) {
    if (!slider) return;
    
    // 延迟初始化，确保 panel 已经完全显示
    setTimeout(() => {
      if (slider.reInstall) {
        slider.reInstall();
      } else if (slider.install) {
        slider.install();
      }
    }, 100);
  }

  function initApTabsProductSwiper() {
    const apTabsSections = document.querySelectorAll(".ap-tabs-product-swiper");
    
    apTabsSections.forEach((section) => {
      // 如果已经初始化过，跳过
      if (section.dataset.apTabsInitialized) return;
      section.dataset.apTabsInitialized = "true";

      const tabPanel = section.querySelector("tab-panel");
      if (!tabPanel) return;

      // 初始化第一个可见标签页的轮播
      const firstVisiblePanel = section.querySelector(".panel:not([aria-hidden])");
      if (firstVisiblePanel) {
        const firstSlider = firstVisiblePanel.querySelector("slider-component");
        initSlider(firstSlider);
      }

      const onTabChange = (event) => {
        if (!event?.detail) return;

        const tab = event.detail.element;
        if (!tab) return;

        const panelId = tab.getAttribute("aria-controls");
        if (!panelId) return;

        const panel = document.getElementById(panelId);
        if (!panel) return;

        // 查找 panel 内的 slider-component
        const slider = panel.querySelector("slider-component");
        initSlider(slider);
      };

      tabPanel.addEventListener("item-active", onTabChange);
    });
  }

  // 初始化
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initApTabsProductSwiper);
  } else {
    initApTabsProductSwiper();
  }

  // 监听 Shopify section 加载事件
  if (typeof document.addEventListener !== "undefined") {
    document.addEventListener("shopify:section:load", initApTabsProductSwiper);
  }
})();

